// Shared XP level definitions and helpers.
// Keep thresholds and colors consistent across all components.
//
// XP sources: +10 first track, +5 reaction+, +2 comment
// Lvl 1→2 = 10 XP  (1x dodanie czasu)
// Lvl 2→3 = 25 XP  (kilka akcji w ~10 min)
// Potem coraz dłuższe odstępy

export const XP_LEVELS = [
  { min: 0,     max: 9,         level: 1,  nameKey: 'xpLevels.1',  color: '#6b7280', emoji: '🔰' },
  { min: 10,    max: 24,        level: 2,  nameKey: 'xpLevels.2',  color: '#64748b', emoji: '🪖' },
  { min: 25,    max: 59,        level: 3,  nameKey: 'xpLevels.3',  color: '#3b82f6', emoji: '🔵' },
  { min: 60,    max: 124,       level: 4,  nameKey: 'xpLevels.4',  color: '#06b6d4', emoji: '🏁' },
  { min: 125,   max: 249,       level: 5,  nameKey: 'xpLevels.5',  color: '#8b5cf6', emoji: '💜' },
  { min: 250,   max: 449,       level: 6,  nameKey: 'xpLevels.6',  color: '#a855f7', emoji: '⚡' },
  { min: 450,   max: 749,       level: 7,  nameKey: 'xpLevels.7',  color: '#f59e0b', emoji: '🏆' },
  { min: 750,   max: 1099,      level: 8,  nameKey: 'xpLevels.8',  color: '#f97316', emoji: '🔥' },
  { min: 1100,  max: 1549,      level: 9,  nameKey: 'xpLevels.9',  color: '#ef4444', emoji: '🎯' },
  { min: 1550,  max: 2149,      level: 10, nameKey: 'xpLevels.10', color: '#ec4899', emoji: '💎' },
  { min: 2150,  max: 2999,      level: 11, nameKey: 'xpLevels.11', color: '#e11d48', emoji: '👑' },
  { min: 3000,  max: 4099,      level: 12, nameKey: 'xpLevels.12', color: '#dc2626', emoji: '🦅' },
  { min: 4100,  max: 5499,      level: 13, nameKey: 'xpLevels.13', color: '#22c55e', emoji: '🥇' },
  { min: 5500,  max: 7299,      level: 14, nameKey: 'xpLevels.14', color: '#16a34a', emoji: '🌟' },
  { min: 7300,  max: Infinity,  level: 15, nameKey: 'xpLevels.15', color: '#f59e0b', emoji: '🏎️' },
];

export function getXpLevel(xp) {
  const userXp = xp || 0;
  return XP_LEVELS.find(l => userXp >= l.min && userXp <= l.max) || XP_LEVELS[0];
}

export function getNextXpLevel(currentLevel) {
  return XP_LEVELS[currentLevel.level] || null;
}

export const XP_SOURCES = [
  { key: 'xpSources.dailyLogin', baseXp: 10, icon: '🔥', descKey: 'xpSources.dailyLoginDesc', dailyLimit: 1 },
  { key: 'xpSources.firstTrack', baseXp: 20, icon: '⏱️', descKey: 'xpSources.firstTrackDesc' },
  { key: 'xpSources.commentReceived', baseXp: 12, icon: '💬', descKey: 'xpSources.commentReceivedDesc' },
  { key: 'xpSources.createPost', baseXp: 10, icon: '✏️', descKey: 'xpSources.createPostDesc', dailyLimit: 1 },
  { key: 'xpSources.trackSession', baseXp: 5, icon: '🏎️', descKey: 'xpSources.trackSessionDesc', dailyLimit: 3 },
  { key: 'xpSources.reactionReceived', baseXp: 5, icon: '👍', descKey: 'xpSources.reactionReceivedDesc' },
  { key: 'xpSources.badgeClaim', baseXp: 5, icon: '🏅', descKey: 'xpSources.badgeClaimDesc' },
  { key: 'xpSources.addFriend', baseXp: 3, icon: '👥', descKey: 'xpSources.addFriendDesc', dailyLimit: 5 },
  { key: 'xpSources.kartRating', baseXp: 7, icon: '⭐', descKey: 'xpSources.kartRatingDesc', dailyLimit: 1 },
];

export function getDailyLoginXp(streak) {
  if (streak >= 61) return 30;
  if (streak >= 31) return 25;
  if (streak >= 15) return 20;
  if (streak >= 8) return 15;
  if (streak >= 4) return 12;
  return 10;
}
